import { useEffect, useRef, useState } from 'react';
import { styled } from 'styled-components';

const AnimationContainer = styled.div`
  transition: width 0.3s ease;
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  display: inline-block;
  white-space: nowrap;
`;

const HorizontalResizeAnimation = ({
  children,
  style,
  ...props
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current && contentRef.current) {
      requestAnimationFrame(() => {
        // @ts-ignore
        const newWidth = contentRef.current?.offsetWidth || 0;
        setWidth(newWidth);
      });
    }
  }, [children]);

  return (
    <AnimationContainer ref={containerRef} style={{ width: `${width}px` }}>
      {/* @ts-ignore */}
      <ContentWrapper ref={contentRef} {...props} {...style}>
        {children as any}
      </ContentWrapper>
    </AnimationContainer>
  );
};

export default HorizontalResizeAnimation;
